import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { UI } from "./translations";

const LanguageContext = createContext(null);

const STORAGE_KEY = "tcp-lang";
const DEFAULT_LANG = "fr";

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return DEFAULT_LANG;
    const saved = window.localStorage.getItem(STORAGE_KEY);
    return saved === "en" || saved === "fr" ? saved : DEFAULT_LANG;
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(STORAGE_KEY, lang);
      document.documentElement.setAttribute("lang", lang);
    }
  }, [lang]);

  const setLang = useCallback((l) => setLangState(l === "en" ? "en" : "fr"), []);
  const toggleLang = useCallback(
    () => setLangState((prev) => (prev === "fr" ? "en" : "fr")),
    [],
  );

  const value = useMemo(
    () => ({
      lang,
      setLang,
      toggleLang,
      t: UI[lang],
    }),
    [lang, setLang, toggleLang],
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return ctx;
}
